var EnhancedSearch = Backbone.View.extend({
  events: {
    "click [data-enhanced-search-param]": "updateFormData",
    "change [data-enhanced-search-param-select]": "updateFormData",
    "click [data-enhanced-search-clear]": "clear",
    "click [data-enhanced-search-clear-all]": "clearAll",
    'change [data-range-slider="du"]': "updateDuration",
    "click [data-enhanced-search-duration-update]": "predefinedDuration"
  },
  initialize: function() {
    this.endpoint = this.$el.data("url");

    // set default parameters
    this.defaultData = JSON.parse(this.$("[data-search-params]").html());
    this.formData = {};

    this.$el.loadComponents();
  },
  clear: function(e) {
    var elData = $(e.currentTarget).data(),
      key = elData["enhancedSearchParamKey"];

    delete this.formData[key];
    this.doPartialSearch("clearSingle", key);
  },
  clearAll: function() {
    this.formData = {};
    return this;
  },
  predefinedDuration: function(e) {
    var newDuration = $(e.currentTarget).data(
      "enhanced-search-duration-update"
    );

    if (newDuration) {
      this.updateDuration(e, newDuration);
    }
  },
  updateDuration: function(e, data) {
    data = data || e.currentTarget.value;
    this.formData["duration_min"] = data.min;
    this.formData["duration_max"] = data.max;

    this.doPartialSearch("update");
  },
  updateFormData: function(e) {
    if (e.type == "change") {
      var elData = $(e.currentTarget).data(),
        key = $(e.currentTarget).attr("name"),
        value = $(e.currentTarget).val();
    } else {
      var elData = $(e.currentTarget).data(),
        key = elData["enhancedSearchParamKey"],
        value = elData["enhancedSearchParamValue"];
    }

    this.formData[key] = value;
    this.doPartialSearch("update", key);
    return this;
  },
  reflowForm: function(response) {
    this.$el.html(response);
    this.$el.loadComponents();
    this.$el.removeClass("is-loading");
  },
  doPartialSearch: function(type, key) {
    this.$el.addClass("is-loading");
    var searchParams = _.clone(this.formData);

    if (type == "clearSingle") {
      if (key == "vendor_id") {
        searchParams.vendor_id = _.allKeys(this.defaultData.cruiseLines);
      } else {
        searchParams[key] = -1;
      }
    }

    $.ajax({
      type: "GET",
      url: this.$el.data("url"),
      dataType: "html",
      data: searchParams,
      cache: false,
      success: this.reflowForm.bind(this),
      error: function() {
        this.$el.html("Unable to retrieve requested data.");
      }
    });
  }
});

module.exports = EnhancedSearch;
